export const buildNavigationUrl = (pathname, parameters = "") => {
  const search = parameters.toString();
  return `${pathname}${search ? `?${search}` : ""}`;
};
